import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Center, Group, List, Loader, ScrollArea, Spoiler, Stack, Text } from "@coveord/plasma-mantine";
import { Locales } from "../../strings/Locales.js";
import { DeletePromptList } from "./DeletePromptList.js";
import classes from "./ProjectsList.module.css";
var VISIBLE_COUNT = 5;
var ProjectListItem = function(param) {
    var project = param.project;
    var name = project.name, createdFrom = project.createdFrom;
    var createdFromDescriptor = createdFrom && Locales.formatOrDefault("DeleteSingleResourcePrompt.description.projectSpecific.listItem.descriptor.".concat(createdFrom), {
        defaultTranslation: Locales.format("DeleteSingleResourcePrompt.description.projectSpecific.listItem.descriptor.default")
    });
    return /*#__PURE__*/ _jsx(List.Item, {
        children: /*#__PURE__*/ _jsxs(Group, {
            gap: "xxs",
            children: [
                /*#__PURE__*/ _jsx(Text, {
                    fw: 500,
                    children: name
                }),
                createdFromDescriptor && /*#__PURE__*/ _jsx(Text, {
                    c: "dimmed",
                    children: createdFromDescriptor
                })
            ]
        })
    });
};
var ProjectListItems = function(param) {
    var items = param.items;
    var visibleProjects = items.slice(0, VISIBLE_COUNT);
    var hiddenProjects = items.slice(VISIBLE_COUNT);
    var _id, _id1;
    return /*#__PURE__*/ _jsxs(ScrollArea.Autosize, {
        mah: 240,
        children: [
            /*#__PURE__*/ _jsx(DeletePromptList, {
                children: visibleProjects.map(function(project, ix) {
                    return /*#__PURE__*/ _jsx(ProjectListItem, {
                        project: project
                    }, (_id = project.id) !== null && _id !== void 0 ? _id : "visible-project-".concat(ix));
                })
            }),
            hiddenProjects.length > 0 && /*#__PURE__*/ _jsx(Spoiler, {
                maxHeight: 0,
                showLabel: Locales.format("DeleteSingleResourcePrompt.description.projectSpecific.spoiler.showLabel", {
                    count: hiddenProjects.length,
                    smart_count: hiddenProjects.length
                }),
                hideLabel: null,
                classNames: {
                    control: classes.control
                },
                children: /*#__PURE__*/ _jsx(DeletePromptList, {
                    children: hiddenProjects.map(function(project, ix) {
                        return /*#__PURE__*/ _jsx(ProjectListItem, {
                            project: project
                        }, (_id1 = project.id) !== null && _id1 !== void 0 ? _id1 : "hidden-project-".concat(ix));
                    })
                })
            })
        ]
    });
};
export var ProjectList = function(param) {
    var projects = param.projects;
    var ref;
    var cannotBeUndoneText = /*#__PURE__*/ _jsx(Text, {
        children: Locales.format("DeleteSingleResourcePrompt.description.projectSpecific.cannotBeUndone")
    });
    if (projects.isLoading) {
        return /*#__PURE__*/ _jsxs(Stack, {
            gap: "sm",
            pr: "xl",
            children: [
                /*#__PURE__*/ _jsx(Center, {
                    children: /*#__PURE__*/ _jsx(Loader, {})
                }),
                cannotBeUndoneText
            ]
        });
    }
    if (projects.isError) {
        return cannotBeUndoneText;
    }
    return /*#__PURE__*/ _jsxs(Stack, {
        gap: "sm",
        children: [
            ((ref = projects.data) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ _jsx(ProjectListItems, {
                items: projects.data
            }),
            cannotBeUndoneText
        ]
    });
};

//# sourceMappingURL=ProjectsList.js.map